import {gql, useLazyQuery, useMutation} from '@apollo/client';
import {
  DeleteReviewsForAccount,
  DeleteReviewsForAccountVariables,
} from '../schema-types/DeleteReviewsForAccount';
import {DeleteReviewsForRegressionAccounts} from '../schema-types/DeleteReviewsForRegressionAccounts';
import {InfoForDeleteReviewsForRegressionAccounts} from '../schema-types/InfoForDeleteReviewsForRegressionAccounts';

export const DELETE_ALL_ACCOUNT_REVIEWS = gql`
  mutation DeleteReviewsForAccount($accountId: UUID!) {
    deleteReviewsForAccount(accountId: $accountId) {
      ok
      errors
    }
  }
`;

export const DELETE_REGRESSION_REVIEWS = gql`
  mutation DeleteReviewsForRegressionAccounts {
    deleteReviewsForRegressionAccounts {
      ok
      errors
    }
  }
`;

export const INFO_DELETE_REGRESSION_REVIEWS = gql`
  query InfoForDeleteReviewsForRegressionAccounts {
    infoForDeleteReviewsForRegressionAccounts {
      text
    }
  }
`;

export const useDeleteAccounts = () => {
  const [
    deleteReviewsForAccount,
    {data: reviewsAccountData, loading: reviewsAccountDataLoading},
  ] = useMutation<DeleteReviewsForAccount, DeleteReviewsForAccountVariables>(
    DELETE_ALL_ACCOUNT_REVIEWS
  );
  const [deleteReviewsForRegressionAccounts, {data: reviewsRegressionData}] =
    useMutation<DeleteReviewsForRegressionAccounts>(DELETE_REGRESSION_REVIEWS);
  const [
    infoDeleteReviewsForRegressionAccounts,
    {data: infoReviewsRegressionData, loading: infoLoading},
  ] = useLazyQuery<InfoForDeleteReviewsForRegressionAccounts>(
    INFO_DELETE_REGRESSION_REVIEWS
  );

  return {
    deleteReviewsForAccount,
    reviewsAccountData,
    deleteReviewsForRegressionAccounts,
    reviewsRegressionData,
    infoDeleteReviewsForRegressionAccounts,
    infoReviewsRegressionText:
      infoReviewsRegressionData?.infoForDeleteReviewsForRegressionAccounts?.text ?? '',
    reviewsAccountDataLoading,
    infoLoading,
  };
};
